export default "__VITE_PUBLIC_ASSET__b175aed7__"